module.exports = __webpack_public_path__ + "static/angry-blorg-0f3f73e5c611ecce5b6a262e40ae3ef3.svg";